module.exports = __webpack_public_path__ + "static/media/awards_12.19da8a1e.jpg";